import * as React from "react";

export const Burger = () => {
    return (
        <>
            <BurgerLine></BurgerLine>
            <BurgerLine></BurgerLine>
            <BurgerLine></BurgerLine>
        </>
    );
};

const BurgerLine = () => {
    return (
        <div className={`mb-[3px] h-[3px] w-[20px] rounded-sm bg-current`} />
    );
};
